import React from 'react';
import { Modal, QRCode } from 'antd';
import { useTranslation } from 'react-i18next';
import { IoClose } from 'react-icons/io5';
import { BASE_URL } from '../../constants/Url';

export default function EventQrModal({ open, onClose, event }) {
  const { t, i18n } = useTranslation();

  if (!event) return null;

  const currentLang = i18n.language === 'en' ? 'en' : (i18n.language === 'zh-HK' ? 'zh-HK' : 'cn');
  const eventData = event.eventsId || event;
  const title = 
    event.localize?.[currentLang]?.title ||
    event.localize?.cn?.title ||
    eventData?.localize?.[currentLang]?.title ||
    eventData?.localize?.cn?.title ||
    eventData?.title ||
    t('text_my_activities');

  const ticketCode = event.ticketCode || eventData?.ticketCode || event.eventId || '';

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      closable={false}
      maskClosable={true}
      width={360}
      styles={{
        content: {
          padding: 0,
          background: 'transparent',
          boxShadow: 'none',
        },
        mask: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          backdropFilter: 'blur(3px)',
        }
      }}
    >
      <div className="flex flex-col items-center">
        {/* Ticket Container */}
        <div className="relative w-full filter drop-shadow-2xl">
          
          {/* Ticket Header */}
          <div className="bg-white rounded-t-2xl px-6 pt-6 pb-2 text-center">
            <h3 className="text-base sm:text-lg font-bold text-gray-900 leading-snug line-clamp-2">
              {title}
            </h3>
          </div>

          {/* Ticket Perforated Divider with Genuine Transparent Cutout Notches */}
          <div 
            className="relative w-full h-7 flex items-center -my-[1px]"
            style={{
              background: `
                radial-gradient(circle 14px at 0 50%, transparent 14px, #ffffff 14.5px) left / 51% 100% no-repeat,
                radial-gradient(circle 14px at 100% 50%, transparent 14px, #ffffff 14.5px) right / 51% 100% no-repeat
              `
            }}
          >
            {/* Dashed line */}
            <div className="w-full mx-[18px] flex items-center overflow-hidden">
              <svg className="w-full h-[2px]" preserveAspectRatio="none">
                <line
                  x1="0"
                  y1="1"
                  x2="100%"
                  y2="1"
                  stroke="#D1D5DB"
                  strokeWidth="2.5"
                  strokeDasharray="12 7"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div>

          {/* Ticket Body: QR Code & Instructions */}
          <div className="bg-white rounded-b-2xl px-6 pt-2 pb-6 flex flex-col items-center text-center">
            <span className="text-sm font-semibold text-gray-700 tracking-wide mb-4">
              {t('text_admission_qr')}
            </span>

            {/* QR Code Container */}
            <div className="p-3 bg-white rounded-xl shadow-inner border border-gray-100 flex items-center justify-center">
              {ticketCode ? (
                <QRCode
                  value={ticketCode}
                  size={200}
                  icon={BASE_URL + '/logo1.svg'}
                  iconSize={36}
                  bordered={false}
                  errorLevel="H"
                />
              ) : (
                <div className="w-[200px] h-[200px] flex items-center justify-center text-gray-400 text-xs">
                  {t('text_no_activities')}
                </div>
              )}
            </div>

            {/* Ticket Code Tag */}
            {ticketCode && (
              <span className="mt-2 text-[11px] font-mono font-medium text-gray-400 tracking-wider">
                {ticketCode}
              </span>
            )}

            {/* Helper Notice */}
            <p className="mt-4 text-xs text-gray-400 flex items-center justify-center gap-1 font-normal">
              <span>ⓘ</span>
              <span>{t('text_qr_one_time')}</span>
            </p>
          </div>
        </div>

        {/* Circular Close Button below ticket */}
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="mt-6 w-11 h-11 rounded-full border border-white/60 bg-black/40 hover:bg-black/60 active:scale-95 text-white flex items-center justify-center transition-all duration-200 cursor-pointer shadow-lg"
        >
          <IoClose size={24} />
        </button>
      </div>
    </Modal>
  );
}
